/*
  Ponte entre as nossas seções (cards, combo, PDP, instashop) e o carrinho do
  Horizon.

  Por que existe: nossas seções adicionavam por fetch e mandavam o cliente para
  /cart, recarregando a página. O tema já tem o efeito "fly to cart" e a gaveta
  que abre sozinha, mas os dois só disparam quando quem adiciona é o
  <product-form-component> nativo. Aqui reproduzimos o mesmo contrato:

    1. dispara CartLinesUpdateEvent(action:'add') ANTES do fetch  -> a gaveta
       decide se vai abrir e o ícone do header entra em estado de carregando
    2. faz o POST /cart/add.js pedindo as seções do carrinho
    3. resolve a promise do evento com o carrinho novo -> a gaveta e o contador
       se redesenham sem recarregar a página

  ATENÇÃO: este arquivo TEM de ser carregado com type="module" e importar
  @shopify/events estaticamente. Com import() dinâmico dentro de um script
  clássico, o pipeline de assets da Shopify transpila a chamada para require(),
  que não existe no browser -- o módulo nunca carrega e todo add cai no
  fallback de ir para /cart.
*/
import { CartLinesUpdateEvent } from '@shopify/events';

(function () {
  'use strict';

  /* As seções do carrinho que precisam ser re-renderizadas no retorno do add. */
  function seccoesDoCarrinho() {
    var ids = [];
    [].forEach.call(document.querySelectorAll('cart-items-component'), function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function iconeDoCarrinho() {
    return document.querySelector('.header-actions__cart-icon') ||
           document.querySelector('.hde__cart') ||
           document.querySelector('cart-icon');
  }

  /*
    Efeito "fly": clona a foto do produto num <fly-to-cart> e deixa o elemento
    do próprio tema animar até o ícone da sacola. Ele se remove sozinho no fim.
  */
  function voar(origem, imagem, estilo) {
    if (!origem || !imagem) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var destino = iconeDoCarrinho();
    if (!destino) return;

    customElements.whenDefined('fly-to-cart').then(function () {
      var el = document.createElement('fly-to-cart');
      el.classList.add(estilo || 'fly-to-cart--quick');
      el.style.setProperty('background-image', 'url(' + imagem + ')');
      el.style.setProperty('--start-opacity', '0');
      el.source = origem;
      el.destination = destino;
      document.body.appendChild(el);
    });
  }

  /*
    items: [{ id, quantity }]  (mesmo formato do /cart/add.js)
    opts:  { source, image, flyStyle, origem }
    Retorna Promise que resolve com o carrinho, ou rejeita com o erro da API.
  */
  function adicionar(items, opts) {
    opts = opts || {};
    var lista = [].concat(items).map(function (i) {
      return { id: Number(i.id), quantity: Number(i.quantity || 1) };
    });
    var total = lista.reduce(function (s, i) { return s + i.quantity; }, 0);

    voar(opts.source, opts.image, opts.flyStyle);

    return comEvento(lista, total, opts);
  }

  /* O tema inteiro reage sem recarregar a página. */
  function comEvento(lista, total, opts) {
    var deferred = CartLinesUpdateEvent.createPromise();
    var alvo = (opts.source && opts.source.isConnected ? opts.source : document.body);

    alvo.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: lista.map(function (i) {
        return { merchandiseId: String(i.id), quantity: i.quantity };
      }),
      promise: deferred.promise
    }));

    var corpo = { items: lista };
    var secs = seccoesDoCarrinho();
    if (secs.length) corpo.sections = secs.join(',');

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(corpo)
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, dados: d }; });
      })
      .then(function (res) {
        if (!res.ok) {
          // Resolve (não rejeita) com didError para a gaveta não abrir vazia.
          return recarregarCarrinho().then(function (cart) {
            deferred.resolve({
              cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
              detail: { didError: true, items: cart.items, source: 'eletrika-cart', itemCount: total }
            });
            var e = new Error(res.dados && (res.dados.description || res.dados.message) || 'Falha ao adicionar');
            e.dados = res.dados;
            throw e;
          });
        }

        var secoes = res.dados && res.dados.sections;
        return recarregarCarrinho().then(function (cart) {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
            detail: {
              didError: false,
              items: cart.items,
              source: 'eletrika-cart',
              itemCount: total,
              sections: secoes
            }
          });
          // O nosso header custom escuta este evento para o contador.
          document.dispatchEvent(new CustomEvent('cart:update', { detail: { cart: cart } }));
          return cart;
        });
      })
      .catch(function (err) {
        deferred.reject(err);
        throw err;
      });
  }

  function recarregarCarrinho() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Abre a gaveta na mão (usado pelo ícone do header). */
  function abrirGaveta() {
    var gaveta = document.getElementById('cart-drawer');
    if (!gaveta || typeof gaveta.open !== 'function') return false;
    gaveta.open();
    return true;
  }

  window.EletrikaCart = { add: adicionar, fly: voar, abrirGaveta: abrirGaveta, iconeDoCarrinho: iconeDoCarrinho };
})();
